import { useMemo } from 'react';
import { Table } from '@/components';
import { usePagination } from '@/hooks';
import { AgendaFilter } from '../models';
import { useAgendas, useAgendasActions } from '../hooks';
import { agendasTableColumns } from '../config';
import { IconButton } from '@mui/material';
import { Delete as DeleteIcon } from '@mui/icons-material';

import styles from './AgendasTable.module.css';

interface AgendasTableProps {
  agendasFilter: AgendaFilter;
}

const AgendasTable = ({ agendasFilter }: AgendasTableProps) => {
  const columns = useMemo(() => agendasTableColumns, []);

  const { currentPage, pageSize, handlePageChange, handlePageSizeChange } =
    usePagination({ initialPage: 1, initialPageSize: 10 });

  const { agendas, totalItems, totalPages, isAgendasLoading } = useAgendas({
    filters: agendasFilter,
    paginated: {
      page: currentPage,
      pageSize,
    },
  });

  const { handleDeleteAgenda } = useAgendasActions();

  const renderActions = (rowData: Record<string, any>) => {
    return (
      <IconButton onClick={() => handleDeleteAgenda(rowData.id)}>
        <DeleteIcon />
      </IconButton>
    );
  };

  return (
    <div className={styles.content}>
      <Table
        columns={columns}
        isLoading={isAgendasLoading}
        data={agendas}
        renderActions={renderActions}
        pagination={{
          totalItems,
          totalPages,
          currentPage,
          rowsPerPage: pageSize,
          onPageChange: handlePageChange,
          onRowsPerPageChange: handlePageSizeChange,
        }}
      />
    </div>
  );
};

export default AgendasTable;
